import * as React from 'react';
import type { IEntityPageConfiguration } from "../entitypagev3/entitypagebase.props";

export interface IEntityPickerProps {
    placeholderText?: string;
    multiselect?: boolean;
    disableAddNew?: boolean;
    disableEditItem?: boolean;
    entityName: string;
    entityConfiguration?: IEntityPageConfiguration;
    entityArgs?: any;
    selection: any[];
    readOnly?: boolean;
    matchKey?: string;
    excludes?: string[];
    expands?: string[];
    modaleTitle?: string | ((props?: any) => any);
    updateButtonI18nTrad?: string;
    onChange: (selectedIds: string[], selected: any[], cancelChange?: () => void) => void;
    forceDefaultView?: boolean;
    startFilters?: any;
    reloadOnCloseDetailModal?: boolean;
}

import(/* webpackChunkName: "initentities" */ "@@components/entities/init").then((mod) => mod.initEntities());

let component = null;

export const EntityPicker = (props: IEntityPickerProps) => {
    if (component) {
        return <React.Suspense fallback={<div />}>{React.createElement(component, props)}</React.Suspense>;
    }
    return null;
};

export function setEntityPicker(pickercomponent: any) {
    component = pickercomponent;
}
